/** @format */
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { Tab } from 'sis-components/tabs/tab-navigation/tab-navigation.component';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CalendarComponent {
    readonly tabs: Tab[] = [
        {
            path: 'student.logged-in.calendar.not-enrolled',
            title: 'UNSCHEDULED_COURSE_UNITS',
        },
        {
            path: 'student.logged-in.calendar.enrolments',
            title: 'COURSE_UNIT_REALISATIONS',
        },
        {
            path: 'student.logged-in.calendar.aborted-and-finished-enrolments',
            id: 'aborted-finished-enrolments-tab',
            title: 'FINISHED_AND_ABORTED_ENROLMENTS',
        },
    ] as const;

    isRightPanelOpen = signal(false);

    toggleRightPanel(): void {
        this.isRightPanelOpen.update(prev => !prev);
    }
}
